<h1>404</h1>
Seite nicht gefunden<br>
<button type="button" class="btn btn-success mt-2" (click)="dashboard()">Zum Dashboard</button>
